// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Design tokens.
 * Define base values such as colors and border radius, and apply them to Bootstrap variables as well.
 */

:root {
  --gh-canvas-default: #ffffff;
  --gh-canvas-subtle: #f6f8fa;
  --gh-canvas-inset: #eaeef2;
  --gh-border-default: #d0d7de;
  --gh-border-muted: #d8dee4;
  --gh-fg-default: #1f2328;
  --gh-fg-muted: #656d76;
  --gh-accent-fg: #0969da;
  --gh-success-fg: #1a7f37;
  --gh-btn-primary-bg: #1f883d;
  --gh-btn-primary-hover: #1a7f37;
  --gh-danger-fg: #cf222e;
  --gh-header-bg: #24292f;
  --gh-radius: 6px;

  --bs-body-bg: var(--gh-canvas-subtle);
  --bs-body-color: var(--gh-fg-default);
  --bs-border-color: var(--gh-border-default);
  --bs-link-color: var(--gh-accent-fg);
  --bs-link-hover-color: var(--gh-accent-fg);
  --bs-border-radius: var(--gh-radius);
}
`, "",{"version":3,"sources":["webpack://./src/styles/variables.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,0BAA0B;EAC1B,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;EAC5B,+BAA+B;EAC/B,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;;EAEhB,qCAAqC;EACrC,qCAAqC;EACrC,2CAA2C;EAC3C,oCAAoC;EACpC,0CAA0C;EAC1C,oCAAoC;AACtC","sourcesContent":["/*\n * Design tokens.\n * Define base values such as colors and border radius, and apply them to Bootstrap variables as well.\n */\n\n:root {\n  --gh-canvas-default: #ffffff;\n  --gh-canvas-subtle: #f6f8fa;\n  --gh-canvas-inset: #eaeef2;\n  --gh-border-default: #d0d7de;\n  --gh-border-muted: #d8dee4;\n  --gh-fg-default: #1f2328;\n  --gh-fg-muted: #656d76;\n  --gh-accent-fg: #0969da;\n  --gh-success-fg: #1a7f37;\n  --gh-btn-primary-bg: #1f883d;\n  --gh-btn-primary-hover: #1a7f37;\n  --gh-danger-fg: #cf222e;\n  --gh-header-bg: #24292f;\n  --gh-radius: 6px;\n\n  --bs-body-bg: var(--gh-canvas-subtle);\n  --bs-body-color: var(--gh-fg-default);\n  --bs-border-color: var(--gh-border-default);\n  --bs-link-color: var(--gh-accent-fg);\n  --bs-link-hover-color: var(--gh-accent-fg);\n  --bs-border-radius: var(--gh-radius);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
